import React from "react";
export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  value?: string;
  title: string;
  placeholder?: string;
  onChange?: (...args: any[]) => any;
  onKeyPress?: (...args: any[]) => any;
}

const InputText: React.FC<InputProps> = (props) => {
  const {
    className,
    title,
    placeholder,
    children,
    onChange,
    onKeyPress,
    value,
    ...rest
  } = props;

  const handleOnChange = (e: any) => {
    if (onChange) {
      onChange(e.target.value);
    }
    return null;
  };

  const handleonKeyPress = (e: any) => {
    if (onKeyPress) {
      onKeyPress(e.key);
    }
    return null;
  };

  return (
    <div className="grid space-y-2 xl:my-4">
      <label htmlFor={title} className="text-textColor font-bold text-xs font-dmSans">
        <p className="mb-1 capitalize font-dmSans text-base font-bold">{title}</p>
        <input
          {...rest}
          id={title}
          type={"text"}
          autoCapitalize="off"
          placeholder={placeholder}
          value={value}
          onChange={handleOnChange}
          onKeyPress={handleonKeyPress}
          className="w-full border-[0.5px] placeholder:text-[10px] text-black focus:outline-none focus:border-[0.5px] bg-white border-textColor focus:border-black p-2 font-semibold rounded-md"
        />
      </label>
    </div>
  );
};

export default InputText;
